import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Logo from '../Logo';
import { Text } from '../Text';
import { Footer, StyledLinearProgress, StyledLinearProgressDesktop, Wrapper } from './styles';

const Sidebar: React.FunctionComponent<any> = ({ children }: any) => {
  const { t } = useTranslation();
  const location = useLocation();

  const progressBar = useMemo(() => {
    const currentStep = () => {
      switch (location.pathname) {
        case '/register':
          return 1;
        case '/welcome':
          return 2;
        case '/insurance-declaration':
          return 5;
        case '/payment-method':
          return 6;
        default:
          return 0;
      }
    };
    return (currentStep() / 6) * 100;
  }, [location]);

  return (
    <>
      <Wrapper>
        <Logo theme="light" />
        {progressBar ? (
          <>
            <StyledLinearProgress variant="determinate" value={progressBar} />
            <StyledLinearProgressDesktop variant="determinate" value={progressBar} />
          </>
        ) : null}
      </Wrapper>
      {children}
      <Footer>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: { md: 'row', xxs: 'column' },
          }}
        >
          <Box sx={{ display: 'flex', gap: { md: 3, xxs: 1 }, flexDirection: { md: 'row', xxs: 'column' } }}>
            <Text color="darkSecondary" variant="content">
              <a
                target="blank"
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                href="https://help.theout.com/hc/en-gb"
              >
                FAQs
              </a>
            </Text>
            <Text color="darkSecondary" variant="content">
              <a
                target="blank"
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                href="https://help.theout.com/hc/en-gb/articles/20886862862749-Contact-Us"
              >
                Contact
              </a>
            </Text>

            <Text color="darkSecondary" variant="content">
              <a
                target="blank"
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                href="https://help.theout.com/hc/en-gb/articles/9949036554141-Privacy-Policy"
              >
                Privacy Policy
              </a>
            </Text>
            <Text color="darkSecondary" variant="content">
              <a
                target="blank"
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                href="https://help.theout.com/hc/en-gb/articles/9948882884125-Terms-and-Conditions-for-renting-a-vehicle"
              >
                Terms & Conditions
              </a>
            </Text>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mt: { md: 0, xxs: 3 } }}>
            <img src="/images/cards/Mastercard-white.svg" width={32} height={20} alt="card" />
            <img src="/images/cards/Card_Amex.svg" width={32} height={20} alt="card" />
            <img src="/images/cards/Visa-blue.svg" width={32} height={20} alt="card" />
            <img src="/images/cards/apple-pay.svg" width={32} height={20} alt="card" />
          </Box>
        </Box>
        <Box sx={{ color: '#707274', fontSize: '14px', mt: { md: 2, xxs: 3 } }}>{t('FOOTER_CONTENT')}</Box>
      </Footer>
    </>
  );
};
export default Sidebar;
